(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-collection-fit-dialog]').forEach((dialog) => {
      if (dialog.dataset.initialized === 'true') return;
      dialog.dataset.initialized = 'true';
      const section = dialog.closest('.shopify-section');
      const openButton = section?.querySelector('[data-collection-fit-open]');
      const closeButton = dialog.querySelector('[data-collection-fit-close]');
      openButton?.addEventListener('click', () => { dialog.showModal(); window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize'))); });
      const closeDialog = () => {
        if (!dialog.open || dialog.classList.contains('is-closing')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          dialog.close();
          return;
        }
        dialog.classList.add('is-closing');
        dialog.addEventListener('animationend', () => dialog.close(), { once: true });
      };
      closeButton?.addEventListener('click', closeDialog);
      dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeDialog(); });
      dialog.addEventListener('close', () => dialog.classList.remove('is-closing'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-by-function-models"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__havnbyVehicleGuideBound) return;
    window.__havnbyVehicleGuideBound = true;
    const setModel = (root, model) => {
      root.querySelectorAll('[data-vg-model]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.vgModel === model));
      });
      root.querySelectorAll('[data-vg-panel]').forEach((panel) => {
        const visible = panel.dataset.vgPanelModel === model;
        panel.hidden = !visible;
      });
    };

    const init = (root) => {
      if (!root) return;
      const panels = [...root.querySelectorAll('[data-vg-panel]')];
      const buttons = [...root.querySelectorAll('[data-vg-model]')];
      buttons.forEach((button) => {
        button.hidden = !panels.some((panel) => panel.dataset.vgPanelModel === button.dataset.vgModel);
      });
      root.hidden = !panels.length && !window.Shopify?.designMode;
      const initial = buttons.find((button) => !button.hidden);
      if (initial) setModel(root, initial.dataset.vgModel);
    };

    document.addEventListener('click', (event) => {
      const modelButton = event.target.closest('.vehicle-guide [data-vg-model]');
      if (modelButton) {
        setModel(modelButton.closest('.vehicle-guide'), modelButton.dataset.vgModel);
        return;
      }
      const scrollButton = event.target.closest('.vehicle-guide [data-vg-scroll]');
      if (!scrollButton) return;
      const list = scrollButton.closest('[data-vg-panel]').querySelector('.vehicle-guide__products');
      const card = list.querySelector('.product-card');
      const distance = card ? card.getBoundingClientRect().width + 20 : list.clientWidth * .7;
      list.scrollBy({ left: distance * (scrollButton.dataset.vgScroll === 'next' ? 1 : -1), behavior: 'smooth' });
    });

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target.querySelector('.vehicle-guide'));
    });
    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('.vehicle-guide [data-vg-panel]');
      if (panel) setModel(panel.closest('.vehicle-guide'), panel.dataset.vgPanelModel);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('.vehicle-guide').forEach(init), { once: true });
    } else {
      document.querySelectorAll('.vehicle-guide').forEach(init);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["havnby-approach"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-hvn-fit-dialog]').forEach((dialog) => {
    if (dialog.dataset.initialized === 'true') return;
    dialog.dataset.initialized = 'true';

    const section = dialog.closest('.shopify-section');
    const openButton = section?.querySelector('[data-hvn-fit-open]');
    const closeButton = dialog.querySelector('[data-hvn-fit-close]');

    openButton?.addEventListener('click', () => {
      if (typeof dialog.showModal !== 'function') return;
      dialog.showModal();
      window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    });

    const closeDialog = () => {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        dialog.close();
        return;
      }
      dialog.classList.add('is-closing');
      dialog.addEventListener('animationend', () => dialog.close(), { once: true });
    };

    closeButton?.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeDialog(); });
    dialog.addEventListener('close', () => dialog.classList.remove('is-closing'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["havnby-collection-fit-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-havnby-fit-dialog]').forEach((dialog) => {
      if (dialog.dataset.initialized === 'true') return;
      dialog.dataset.initialized = 'true';
      const section = dialog.closest('.shopify-section');
      const openButton = section?.querySelector('[data-havnby-fit-open]');
      const closeButton = dialog.querySelector('[data-havnby-fit-close]');
      openButton?.addEventListener('click', () => { dialog.showModal(); window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize'))); });
      closeButton?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["havnby-comparison"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.snugnest-comparison').forEach((section) => {
    const items = section.querySelectorAll('.snugnest-comparison__item');

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.removeAttribute('open');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["havnby-ugc-video-wheel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-video-carousel')) {
    customElements.define('ugc-video-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.cards = [...this.querySelectorAll('[data-carousel-card]')];
        this.dots = [...this.querySelectorAll('[data-carousel-dot]')];
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.activeIndex = 0;
        this.timer = null;
        this.pointerStartX = null;

        if (!this.track || !this.cards.length) return;

        this.previousButton?.addEventListener('click', () => this.step(-1));
        this.nextButton?.addEventListener('click', () => this.step(1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.carouselDot))));

        this.querySelectorAll('[data-video-play]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.playVideo(button.closest('[data-carousel-card]'));
          });
        });

        this.cards.forEach((card, index) => {
          card.addEventListener('click', () => {
            if (index !== this.activeIndex) this.goTo(index);
          });
        });

        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.step(-1);
          if (event.key === 'ArrowRight') this.step(1);
        });

        this.track.addEventListener('pointerdown', (event) => {
          this.pointerStartX = event.clientX;
        });

        this.track.addEventListener('pointerup', (event) => {
          if (this.pointerStartX === null) return;
          const distance = event.clientX - this.pointerStartX;
          this.pointerStartX = null;
          if (Math.abs(distance) < 40) return;
          this.step(distance > 0 ? -1 : 1);
        });

        this.track.addEventListener('pointercancel', () => { this.pointerStartX = null; });

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
        document.addEventListener('visibilitychange', this.handleVisibility = () => {
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        });

        this.resizeObserver = new ResizeObserver(() => this.render());
        this.resizeObserver.observe(this.track);
        this.render();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.resizeObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }

      step(direction) {
        this.goTo((this.activeIndex + direction + this.cards.length) % this.cards.length);
      }

      goTo(index) {
        if (index === this.activeIndex) return;
        this.pauseAllVideos();
        this.activeIndex = index;
        this.render();
        this.restartAutoplay();
      }

      render() {
        const count = this.cards.length;
        const cardWidth = this.cards[0]?.offsetWidth || 300;
        const gap = parseFloat(getComputedStyle(this).getPropertyValue('--ugc-section-gap')) || 24;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const desiredDistance = (cardWidth + gap) * 0.68;
        const safeEdge = 24;
        const outerScale = 0.8;
        const availableDistance = Math.max(
          cardWidth * 0.36,
          (this.track.clientWidth / 2 - cardWidth * outerScale / 2 - safeEdge) / 2
        );
        const distance = isMobile
          ? (cardWidth + gap) * 0.62
          : Math.min(desiredDistance, availableDistance);

        this.cards.forEach((card, index) => {
          let offset = index - this.activeIndex;
          if (offset > count / 2) offset -= count;
          if (offset < -count / 2) offset += count;

          const previousOffset = Number(card.dataset.wheelOffset);
          if (Number.isFinite(previousOffset) && Math.abs(previousOffset - offset) > 1) {
            card.classList.add('is-repositioning');
            requestAnimationFrame(() => card.classList.remove('is-repositioning'));
          }

          const active = index === this.activeIndex;
          const depth = Math.abs(offset);
          const visible = depth <= 2;
          const scale = active ? 1 : depth === 1 ? 0.9 : 0.8;
          const verticalOffset = active ? 0 : depth === 1 ? 12 : 24;
          card.dataset.wheelOffset = String(offset);
          card.style.setProperty('--ugc-x', `${offset * distance}px`);
          card.style.setProperty('--ugc-y', `${verticalOffset}px`);
          card.style.setProperty('--ugc-scale', String(scale));
          card.style.setProperty('--ugc-opacity', visible ? '1' : '0');
          card.style.zIndex = String(100 - depth);
          card.style.pointerEvents = visible ? 'auto' : 'none';
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-hidden', active ? 'false' : 'true');

          const playButton = card.querySelector('[data-video-play]');
          if (playButton) playButton.tabIndex = active ? 0 : -1;
          const video = card.querySelector('video');
          if (video) video.tabIndex = active ? 0 : -1;
        });

        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      pauseAllVideos() {
        this.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.closest('[data-carousel-card]')?.classList.remove('is-playing');
        });
      }

      playVideo(card) {
        if (!card) return;

        let video = card.querySelector('video');
        if (!video) {
          const template = card.querySelector('[data-video-template]');
          const media = card.querySelector('.ugc-video-carousel__media');
          if (!template || !media) return;
          media.insertBefore(template.content.cloneNode(true), media.firstChild);
          video = media.querySelector('video');
        }
        if (!video) return;

        this.pauseAllVideos();

        card.classList.add('is-playing');
        this.stopAutoplay();
        video.load();
        video.play().catch(() => card.classList.remove('is-playing'));
        video.addEventListener('pause', () => card.classList.remove('is-playing'), { once: true });
        video.addEventListener('ended', () => card.classList.remove('is-playing'), { once: true });
      }

      startAutoplay() {
        if (this.dataset.autoplay !== 'true' || this.cards.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stopAutoplay();
        const interval = Number(this.dataset.interval) || 5000;
        this.timer = window.setInterval(() => this.step(1), interval);
      }

      stopAutoplay() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
